'use client';

import React from 'react';
import { Checkbox } from 'src/components/PulseUI';

interface StrategyItemProps {
  strategy: { id: number; label: string; description?: string };
  isChecked: boolean;
  dotClass: string;
  onToggle: (chainId: number) => void;
}

const StrategyItem = ({
  strategy,
  isChecked,
  dotClass,
  onToggle,
}: StrategyItemProps) => {
  return (
    <div
      data-testid={`strategy-option-${strategy.id}`}
      onClick={() => onToggle(strategy.id)}
      className="flex items-center gap-3 px-4 py-3 cursor-pointer hover:bg-neutral-50 transition-colors"
      role="option"
      aria-selected={isChecked}
    >
      <Checkbox
        checked={isChecked}
        onChange={() => onToggle(strategy.id)}
        size="sm"
        variant="solid"
        color="primary"
      />
      <div className="flex flex-col gap-0.5 min-w-0">
        <div className="flex items-center gap-2">
          <span
            className={`w-2.5 h-2.5 rounded-full flex-shrink-0 ${dotClass}`}
            data-testid={`strategy-dot-${strategy.id}`}
            aria-hidden="true"
          />
          <span className="text-sm font-medium text-primary">
            {strategy.label}
          </span>
        </div>
        {strategy.description && (
          <div className="text-xs text-tertiary">
            {strategy.description}
          </div>
        )}
      </div>
    </div>
  );
};

export default StrategyItem;
